import { createReducer, createActions } from "reduxsauce";
import Immutable from "seamless-immutable";

const { Types, Creators } = createActions({
  getCalendarEventsRequest: ["navigate"],
  getCalendarEventsSuccess: ["calendar"],
  getCalendarEventsFailure: null,
});

export const GetCalendarEventsTypes = Types;
export default Creators;

export const INITIAL_STATE = Immutable({
  fetching: null,
  success: null,
  error: null,
  calendar: null,
});

export const GetCalendarEventsSelectors = {
  getData: (state: any) => state.getCalendarEvents.calendar,
  isFetching: (state: any) => state.getCalendarEvents.fetching,
  isSuccess: (state: any) => state.getCalendarEvents.success,
  hasError: (state: any) => state.getCalendarEvents.error,
};

export const request = (state: any, action: any) => {
  const updateData = {
    fetching: true,
    success: null,
    error: null,
    calendar: null,
  };
  return state.merge ? state.merge(updateData) : { ...state, ...updateData };
};

export const success = (state: any, action: any) => {
  console.log('GetCalendarEventsSelectors ---- ', action);
  const { calendar } = action;
  const updateData = {
    fetching: false,
    success: true,
    error: false,
    calendar,
  };
  return state.merge ? state.merge(updateData) : { ...state, ...updateData };
};

export const failure = (state: any) => {
  const updateData = {
    fetching: false,
    success: false,
    error: true,
    calendar: null,
  };
  return state.merge ? state.merge(updateData) : { ...state, ...updateData };
};

export const reducer = createReducer(INITIAL_STATE, {
  [Types.GET_CALENDAR_EVENTS_REQUEST]: request,
  [Types.GET_CALENDAR_EVENTS_SUCCESS]: success,
  [Types.GET_CALENDAR_EVENTS_FAILURE]: failure,
});
